import { type ReactNode } from 'react'
import { useMatches } from 'react-router'
import { MarketingPageShell } from './marketing-page-shell.tsx'

/** Routes with their own shared header/footer opt out of the default shell. */
export function SiteLayout({ children }: { children: ReactNode }) {
	const matches = useMatches()
	const hasOwnShell = matches.some(
		(match) =>
			(match.handle as { chrome?: string } | undefined)?.chrome === 'payload',
	)

	return hasOwnShell ? (
		children
	) : (
		<MarketingPageShell>{children}</MarketingPageShell>
	)
}
